
export class CreateTourCommand {
    public title: String;
    public description: String;
    public image: File;
    public imageLink: string;
    public imageBase64: string;
    public order: number;
    public attraction: [{
        type: String,
        id: String,
        order: Number
    }];
    public isActive: Boolean;
}

export class TourAttractionCommand {
    public id: string;
    public attractions: TourAttraction[];
}

export class TourAttraction {
    feedType: String;
    feedId: String;
    order: Number
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/hub/create.tour.command.ts